import { render, staticRenderFns } from "./fareSelect.vue?vue&type=template&id=49a956ea&"
import script from "./fareSelect.vue?vue&type=script&lang=js&"
export * from "./fareSelect.vue?vue&type=script&lang=js&"
import style0 from "./fareSelect.vue?vue&type=style&index=0&id=49a956ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports